export const UPDATE_STATEMENT_PROCESS_REQUEST = 'UPDATE_STATEMENT_PROCESS_REQUEST';

export const updateStatementProcessRequest = ( id, formData ) => ({
    type: UPDATE_STATEMENT_PROCESS_REQUEST,
    payload: { id, formData  }
});
